exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-09f5a1b1] .el-select__tags{cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;overflow:hidden;overflow-x:auto}.plan-footer-one[data-v-09f5a1b1]{height:26px;line-height:28px}.flex-box span[data-v-09f5a1b1]{margin-right:6px}.flex-box span[data-v-09f5a1b1]:last-of-type{margin-right:0}.flex-box .tag[data-v-09f5a1b1]{background-color:F0F2F5;border:none}[data-v-09f5a1b1] .el-select__input{cursor:pointer}[data-v-09f5a1b1] .el-select__tags::-webkit-scrollbar{display:none}[data-v-09f5a1b1] .from-s .flex-row .el-form-item{margin-right:10px;margin-left:0}\n", ""]);

// exports
